import { Box, Chip, Divider, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import _ from 'lodash'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** STYLE */
import useStyles from 'features/setting/personnel-managements/personnels/style'

/** API */
import PositionApi from 'api/setting/personnel-managements/position.api'
import RolesApi from 'api/setting/personnel-managements/role.api'

/** UTILS || SLICE */
import { editSalary, selectLoadingSalary, selectUserSalary } from 'app/slice/user.slice'

/** CONSTANT */
import { fileUrl } from 'api/api'
import BanksApi from 'api/setting/finances/bank.api'
import TagsApi from 'api/setting/personnel-managements/tags.api'
import AutocompleteSelect from 'component/Select/AutocompleteSelect'
import { onImgError } from 'constants/images'
import { colors } from 'constants/theme'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'

const freeCreditCard = [0, 1.25, 1.375, 1.5, 2.4, 2.5, 3]

interface SelectBank {
  bankId: number
  bankName?: string
  bankAccountNumber: string
  bankAccountName: string
  src?: string
}
interface SalarynPositionProps {
  isEdit: boolean
  errorMessage?: any
  user?: any
  resetErrorMessage?: (type: string) => void
}
export default function SalarynPosition(props: SalarynPositionProps) {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const userSalary = useSelector(selectUserSalary)
  const loadingsalary = useSelector(selectLoadingSalary)
  const [positions, setPositions] = useState([])
  const [roles, setRoles] = useState<any[]>([])
  const [banks, setBanks] = useState<any[]>([])
  const [tableBranceh, setTableBranchs] = useState<any[]>([])
  const [certificate, setCertificate] = useState('')
  const [creditCardFee, setCreditCardFee] = useState<number>(0)
  const [bankAccountNumber, setBankAccountNumber] = useState('')
  const [bankAccountName, setBankAccountName] = useState('')
  const [isInsure, setIsInsure] = useState('')
  const [positionId, setPositionId] = useState<number>(0)
  const [roleId, setRoleId] = useState<number>(0)
  const [salary, setSalary] = useState<number>(0)
  const [selectBank, setSelectBank] = useState<SelectBank | null>(null)
  const classes = useStyles()
  const [searchInput, setSearchInput] = useState<string>('')
  const [maganeTag, setManageTag] = useState<any[]>([])
  const [loadTags, setLoadTags] = useState<boolean>(false)

  const costConditions = [
    { label: t('PERSONNEL.SALARY.STATUS.HAVE'), value: true, labelId: 1 },
    { label: t('PERSONNEL.SALARY.STATUS.NO_HAVE'), value: false, labelId: 2 }
  ]
  const loadDataPosition = useCallback(async () => {

    const positionsApi = await PositionApi.findAll({ pageLimit: 999, status: 'ACTIVE' })
    if (positionsApi.status === 200) {
      setPositions(positionsApi.data)
    }
  }, [])
  const loadDataBank = async () => {
    await BanksApi.findAll({ pageLimit: 999, status: 'ACTIVE' }).then(({ data }) => data && setBanks(data))
  }

  const loadDataRole = useCallback(async () => {

    const rolesApi = await RolesApi.findAll({ pageLimit: 999, status: 'ACTIVE' })

    if (rolesApi.status === 200) {
      setRoles(rolesApi.data)
    }
  }, [])

  const loadTableBranchsAndService = useCallback(async (valueRoleId: number) => {
    if (valueRoleId) {
      const res: any = await RolesApi.findById(valueRoleId)
      if (res.status === 200) {
        const objArr: any = _.map(_.groupBy(res.data?.roleBranches, 'branchId'), (r: any) => {
          return {
            branch: r[0]?.branches?.branchName,
            servicePoints: _.map(r, (s: any) => ({ servicePoint: s?.servicePoints?.servicePointName }))
          }
        })

        setTableBranchs(objArr)
      }
    }
  }, [roleId])

  useEffect(() => { init() }, [loadDataPosition, loadingsalary, positionId, roleId])
  const init = async () => {
    loadDataPosition()
    await loadDataBank()
    loadDataRole()
    if (!loadingsalary) {
      setBankAccountName(userSalary.bankAccountName || '')
      setBankAccountNumber(userSalary.bankAccountNumber || '')
      setCertificate(userSalary.certificate || '')
      setCreditCardFee(userSalary.creditCardFee || '')
      setIsInsure(userSalary.isInsure || '')
      setPositionId(userSalary.positionId || 0)
      setRoleId(userSalary.roleId || 0)
      loadTableBranchsAndService(userSalary.roleId || 0)
      setSalary(userSalary.salary || 0)
      const bankOptions = await BanksApi.findAll({ pageLimit: 999, status: 'ACTIVE' }).then(({ data }) => data)

      const bankObj = bankOptions.find((obj: any) => obj.bankId === userSalary.bankId)
      let bankSrc: any = ''
      if (bankObj) {
        const { image } = bankObj
        bankSrc = `${fileUrl}/${image?.filePath}/${image?.fileName}`

      }
      const tempSelectBank: SelectBank = {
        bankId: userSalary.bankId || 0,
        bankName: bankObj?.bankName || '',
        bankAccountNumber: userSalary.bankAccountNumber || '',
        bankAccountName: userSalary.bankAccountName || '',
        src: bankSrc
      }

      setSelectBank(tempSelectBank)
    }
  }

  const loadDataTags = async () => {
    let condition: any = { page: 1, pageLimit: 50, status: "ACTIVE" }
    if (searchInput) condition = { ...condition, search: searchInput }
    const res = await TagsApi.findAll(condition).finally(() => setLoadTags(false))
    if (res.status === 200) {
      setManageTag(res.data)
    }
  }

  useEffect(() => {
    loadDataTags()
  }, [searchInput])

  return (
    <Box sx={{ p: 3, width: '100%', height: 'calc(100vh - 35vh)', overflowY: 'auto', overflowX: 'hidden' }}>
      <Typography sx={{ fontSize: 20, fontWeight: 600 }}>{t('PERSONNEL.SALARY.POSITION_ROLE')}</Typography>
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12} sm={3}>
          <SelectInput
            required
            label={t('PERSONNEL.SALARY.POSITION_NAME')}
            value={positionId || ''}
            onChange={(e: any) => {
              const v = e.target.value
              setPositionId(v)
              dispatch(editSalary({ key: 'positionId', value: v }))
              if (Number(v) !== 2) {
                setCertificate('')
                dispatch(editSalary({ key: 'certificate', value: '' }))
              }
              props.resetErrorMessage?.('salary')
            }}
            options={positions.map((opt: any) => ({
              value: opt.positionId,
              name: opt.positionName
            }))}
            helperText={props.errorMessage.POSITION}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextInput
            required
            label={t('PERSONNEL.SALARY.PROFESSIONAL_LICENSE_NUMBER')}
            value={certificate}
            disabled={!positionId || Number(positionId) !== 2}
            inputProps={{ maxLength: 20 }}
            onChange={(e: any) => {
              const v = e.target.value
              setCertificate(v)
              dispatch(editSalary({ key: 'certificate', value: v }))
              props.resetErrorMessage?.('salary')
            }}
            helperText={props.errorMessage.CERTIFICATE}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <SelectInput
            required
            label={t('PERSONNEL.SALARY.ROLE_NAME')}
            value={roleId || ''}
            onChange={(e: any) => {
              const v = e.target.value
              setRoleId(v)
              dispatch(editSalary({ key: 'roleId', value: v }))
              loadTableBranchsAndService(v)
              props.resetErrorMessage?.('salary')
            }}
            options={roles.map((opt) => ({
              value: opt.roleId,
              name: opt.roleName
            }))}
            helperText={props.errorMessage.ROLE}
          />
        </Grid>
      </Grid>

      {/* แท็ก */}
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12} sm={9}>
          <Box sx={{ color: '#808080', fontSize: 12, mb: 0.5 }}>{t('TAGS.FORM.SELECT_TAGS_MAX')}</Box>
          <AutocompleteSelect
            multiple
            labelId={`tag`}
            inputLabel={t('Tag')}
            options={[...maganeTag]}
            noOptionsText={t('NOT_FOUND')}
            getOptionLabel={(option: any) => `${option?.tagId || ''}`}
            inputValue={searchInput}
            renderOption={(props, option) => {
              const dataSelect = userSalary?.userTags?.some((item: any) => item?.tagId === option?.tagId) || false
              return (
                <Box
                  {...props}
                  key={`tag-select-${option.tagId}`}
                  sx={{
                    pointerEvents: (userSalary?.userTags?.length >= 10 && !dataSelect) ? 'none' : '',
                    backgroundColor: dataSelect ? colors.themeSecondColor06 : colors.white,
                    color: dataSelect ? `${colors.themeSecondColor} !important` : userSalary?.userTags?.length >= 10 ? '#808080' : '',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px'
                  }}
                  onClick={() => {
                    const checkDup = userSalary?.userTags?.some((item: any) => item.tagId === option.tagId)
                    const newData = userSalary?.userTags ? [...userSalary?.userTags] : []
                    if (!checkDup) {
                      const newValue = option
                      dispatch(editSalary({ value: [...newData, newValue], key: 'userTags' }))
                      setSearchInput('')
                    } else {
                      const newValue = newData.filter((item: any) => item.tagId !== option.tagId)
                      dispatch(editSalary({ value: newValue, key: 'userTags' }))
                      setSearchInput('')
                    }
                  }}
                >
                  <Box sx={{ width: '16px', height: '16px', borderRadius: "50%", backgroundColor: option.color, border: '1px solid #fff' }} />
                  <Box>
                    {option.tagName}
                  </Box>
                </Box>
              )
            }}
            renderTags={(tagValue, getTagProps) => {
              return (
                <>
                  <Box className=''>
                    {_.map(tagValue, (item: any, index: number) => {
                      return (
                        <span key={index}>
                          <Chip
                            icon={<Box sx={{ width: '16px', height: '16px', borderRadius: "50%", backgroundColor: item.color, border: '1px solid #fff' }} />}
                            label={item.tagName}
                            sx={{ fontSize: '14px', backgroundColor: '#F7F7F7' }}
                            {...getTagProps({ index })}
                            onDelete={() => {
                              const newData = [...userSalary?.userTags]
                              const newValue = newData.filter((info: any) => info.tagId !== item.tagId)
                              dispatch(editSalary({ value: newValue, key: 'userTags' }))
                              setSearchInput('')
                            }}
                          />
                        </span>
                      )
                    })}
                  </Box>
                </>
              )
            }}
            value={userSalary?.userTags || []}
            loading={loadTags}
            onInputChange={(event: any, newValue: any, reason) => {
              if (reason === 'input') {
                setSearchInput(newValue)
              }
            }}
            filterOptions={(option) => option?.tagName || ''}
            disableClearable
            limitTags={10}
            height={40}
          />
        </Grid>
      </Grid>
      <Divider sx={{ mx: 0, mt: 3, mb: 3, bgcolor: colors.lightGray, opacity: 1, border: 'none' }} />
      <Typography sx={{ fontSize: 20, fontWeight: 600 }}>{t('PERSONNEL.SALARY.BRANCH_SERVICE')} </Typography>
      {tableBranceh.length > 0 ? (
        <TableContainer component={Paper} sx={{ mt: 2, boxShadow: 'none', border: `1px solid ${colors.lightGray}` }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><Typography sx={{ fontWeight: 600 }}>{t('PERSONNEL.SALARY.BRANCH')}</Typography></TableCell>
                <TableCell><Typography sx={{ fontWeight: 600 }}>{t('PERSONNEL.SALARY.SERVICE')}</Typography></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tableBranceh.map((b, i) => (
                <TableRow key={i}>
                  <TableCell>
                    <Typography>{`${i + 1}. ${b.branch || ''}`}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography>
                      {(b.servicePoints || []).map((s: any) => s.servicePoint).join(', ')}
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Typography sx={{ mt: 2, fontSize: 16, color: '#808080' }}>
          {t('PERSONNEL.SALARY.NO_DATA')}
        </Typography>
      )}
      <Divider sx={{ mx: 0, mt: 3, mb: 0, bgcolor: colors.lightGray, opacity: 1, border: 'none' }} />
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12}>
          <Typography sx={{ fontSize: 20, fontWeight: 600 }}>{t('PERSONNEL.SALARY.COMPENSATION')}</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextInput
            label={t('PERSONNEL.SALARY.SALARY')}
            value={salary}
            onChange={(e: any) => {
              const val = e.target.value.replace(/[^0-9.]/g, '')
              setSalary(val)
              dispatch(editSalary({ key: 'salary', value: val }))
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <SelectInput
            label={t('PERSONNEL.SALARY.INSURANCE')}
            value={(isInsure === '1').toString()}
            onChange={e => {
              const v = e.target.value ? '1' : '0'
              setIsInsure(v)
              dispatch(editSalary({ key: 'isInsure', value: v }))
            }}
            options={costConditions.map((c: any) => ({
              value: c.value,
              name: c.label
            }))}

          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <SelectInput
            label={t('PERSONNEL.SALARY.CREDIT_CART')}
            value={creditCardFee}
            onChange={e => {
              const v = e.target.value
              setCreditCardFee(v)
              dispatch(editSalary({ key: 'creditCardFee', value: v }))
              dispatch(editSalary({ key: 'creditCardFeeType', value: 'PERCENT' }))
            }}
            options={freeCreditCard.map((f) => ({
              value: f,
              name: `${f} %`
            }))}

          />
        </Grid>
      </Grid>
      <Divider sx={{ mx: 0, mt: 3, mb: 3, bgcolor: colors.lightGray, opacity: 1, border: 'none' }} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography sx={{ fontSize: 20, fontWeight: 600 }}>{t('PERSONNEL.SALARY.BANK')}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Box sx={{ pl: { xs: 0, xl: 3 }, display: 'flex', flexWrap: 'wrap' }}>
            {banks.map((bank: any, i: number) => {
              const { bankId, bankName, image } = bank
              const bankSrc: any = `${fileUrl}/${image?.filePath}/${image?.fileName}`
              return (
                <img
                  className={`${classes.bank} ${selectBank?.bankId === bankId ? 'btn-bank active' : ''}`}
                  style={{ marginRight: '8px', marginBottom: '8px', padding: '4px' }}
                  key={i}
                  src={`${bankSrc}`}
                  alt=""
                  onError={onImgError}
                  onClick={() => {
                    const tempBank = { bankId, bankAccountNumber: '', bankAccountName: '', bankName, src: bankSrc }
                    dispatch(editSalary({ value: parseInt(tempBank.bankId), key: 'bankId' }))
                    dispatch(editSalary({ value: tempBank.bankAccountName, key: 'bankAccountName' }))
                    dispatch(editSalary({ value: tempBank.bankAccountNumber, key: 'bankAccountNumber' }))
                    setBankAccountName(tempBank.bankAccountName)
                    setBankAccountNumber(tempBank.bankAccountNumber)
                    if (selectBank?.bankId === bankId) setSelectBank(null)
                    else setSelectBank(tempBank)
                  }}
                />
              )
            })}
          </Box>
        </Grid>
        {selectBank && (
          <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
            <Grid item>
              <Box
                component="img"
                src={selectBank.src}
                onError={onImgError}
                sx={{ width: 64, height: 40, objectFit: 'contain', p: 1, border: '1px solid #ccc', borderRadius: 1 }}
              />
              <Typography sx={{ ml: 1 }}>{selectBank.bankName}</Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextInput
                label={t('PERSONNEL.SALARY.ACCOUNT_NAME')}
                value={bankAccountName}
                inputProps={{ maxLength: 20 }}
                onChange={(e: any) => {
                  const v = e.target.value
                  setBankAccountName(v)
                  dispatch(editSalary({ key: 'bankAccountName', value: v }))
                }}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextInput
                label={t('PERSONNEL.SALARY.ACCOUNT_NUMBER')}
                value={bankAccountNumber}
                inputProps={{ maxLength: 20 }}
                onChange={(e: any) => {
                  const v = e.target.value
                  setBankAccountNumber(v)
                  dispatch(editSalary({ key: 'bankAccountNumber', value: v }))
                }}
                fullWidth
              />
            </Grid>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
